import { render, staticRenderFns } from "./system.svg.vue?vue&type=template&id=11ca91b3&"
import script from "./system.svg.vue?vue&type=script&lang=js&"
export * from "./system.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports